/**
 * Parse a structured update block from an assistant message — Spec 64 Phase D.
 *
 * Assistant prompts must emit one exact JSON object:
 * `{ "type": "<entity>-update", "updates": { ... } }`
 *
 * where `updates` holds the form-field patches. workflow-plan (planMode) uses
 * `{ "type": "workflow-plan", "operations": [...] }` and is intentionally NOT
 * extracted here — plan-mode flows through a separate review surface, not the
 * pill picker.
 */
import { parseStrictJsonRecord } from '@confluent/shared/lib/strict-json';

/**
 * Returns the `updates` object — the partial patch the host form should apply
 * — or null when no recognized block is present.
 */
export function parseApplyBlock(content: string): Record<string, unknown> | null {
  const parsed = parseStrictJsonRecord(content);
  const type = parsed?.type;
  const updates = parsed?.updates;
  if (
    typeof type === 'string' &&
    type.endsWith('-update') &&
    updates !== null &&
    typeof updates === 'object' &&
    !Array.isArray(updates)
  ) {
    return updates as Record<string, unknown>;
  }

  return null;
}
